export * from './berichts-vorlagen-list.component';
export * from './berichts-vorlagen-list.component.module';